import React, { memo, useState } from 'react';
import styles from 'Custom/HealthProvider/index.module.scss';
import Container from 'Nori/Container/index';
import Image from 'next/image';
import Button from 'Nori/Button';
import RichText from 'Custom/RichText/index';
import ModalSmall from 'Nori/Modal/ModalSmall';
import CloseIcon from '@/public/assets/images/brand-icons/close-modal-nexplanon.svg';

import { CHAT_ICON, HEALTH_PROVIDER_COPY, BULLETS_INFORMATION } from './utils';

const HealthProvider = ({
  button = HEALTH_PROVIDER_COPY.button,
  title = HEALTH_PROVIDER_COPY.title,
  body = HEALTH_PROVIDER_COPY.body,
  moduleNumber = '00',
  className = '',
  children,
  ...props
}) => {
  const [modalProvider, setModalProvider] = useState(false);

  return (
    <section
      className={`${styles.wrapper} ${className}`}
      data-design-visible="visible_vd"
      data-design-type="module"
      data-design-nori_id="CTA"
      data-design-module_name={title}
      data-design-module_no={moduleNumber}
    >
      <Container>
        <div className={styles.container}>
          <Image
            className={styles.messageIcon}
            src={CHAT_ICON}
            width={202}
            height={180}
            alt="Message icon"
          />
          <RichText className={styles.content}>
            <h2>{title}</h2>
            <p>{body}</p>
          </RichText>
          <Button
            className={styles.cta}
            onClick={() => {
              setModalProvider(true);
            }}
            type="secondary4"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Expand"
            data-design-label={button}
            data-design-nori_id="CTA"
            data-design-module_name={title}
            data-design-module_no={moduleNumber}
          >
            {button}
          </Button>
        </div>
      </Container>

      <ModalSmall
        className={`${styles.modal}`}
        isOpen={modalProvider}
        onClose={() => {
          setModalProvider(false);
        }}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Modal"
        data-design-module_name="think NEXPLANON is right for you?"
        data-design-module_no="00"
      >
        <div className={styles.closeIcon}>
          <CloseIcon
            data-design-category="button_vd"
            data-design-type="clickAction"
            data-design-action="Close"
            data-design-label="close icon"
            data-design-nori_id="Modal"
            data-design-module_name="think NEXPLANON is right for you?"
            data-design-module_no="00"
            onClick={() => {
              setModalProvider(false);
            }}
          />
        </div>

        <RichText className={styles.modalCotnent}>
          <p className="h2 centered">think NEXPLANON is right for you?</p>
          <p className="centered">
            <strong>
              talk to an independent healthcare professional online about all of
              your birth control options
            </strong>
          </p>

          <div className={styles.bulletsInformation}>
            {BULLETS_INFORMATION.map((item, i) => (
              <div className={styles.bulletRow} key={`item-${i}`}>
                <div className={styles.iconContainer}>
                  <Image
                    className={styles.messageIcon}
                    src={item.image.src}
                    width={item.image.width}
                    height={item.image.height}
                    alt={item.image.alt}
                  />
                </div>
                <p>{item.copy}</p>
              </div>
            ))}
          </div>

          <p>The button below will take you to a site outside of Organon.</p>
          <div className={styles.buttonWrapper}>
            <Button
              href="https://www.upscriptbirthcontrolcounseling.com/products/bccounseling/"
              target="_blank"
              rel="noopener"
              onClick={() => {
                setModalProvider(false);
              }}
              data-design-category="button_vd"
              data-design-type="clickAction"
              data-design-action="Link"
              data-design-label="talk to a healthcare professional"
              data-design-nori_id="Modal"
              data-design-module_name="think NEXPLANON is right for you?"
              data-design-module_no="00"
            >
              talk to a healthcare professional
            </Button>
            <Button
              onClick={() => {
                setModalProvider(false);
              }}
              data-design-category="button_vd"
              data-design-type="clickAction"
              data-design-action="Close"
              data-design-label="return to site"
              data-design-nori_id="Modal"
              data-design-module_name="think NEXPLANON is right for you?"
              data-design-module_no="00"
            >
              return to site
            </Button>
          </div>
          <p>
            Organon is providing this link to a third-party website to help
            patients connect virtually with an independent healthcare
            professional.
          </p>
          <p>
            Organon does not own or operate the third-party site and does not
            endorse or recommend any of the healthcare professionals associated
            with the third-party site. You are responsible for assessing the
            qualifications of the healthcare professional and any medical advice
            that is provided.
          </p>
        </RichText>
      </ModalSmall>
    </section>
  );
};

const MemoFinder = memo(HealthProvider);

export { MemoFinder as HealthProvider };
